import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About Alvi Construction</h2>
            <p className="about-description">
              With over 20 years of experience in the construction industry, BuildPro 
              Construction has established itself as a trusted name in delivering 
              exceptional building solutions. Our commitment to quality, safety, and 
              customer satisfaction sets us apart.
            </p>
            <p className="about-description">
              We pride ourselves on our attention to detail, innovative approaches, and 
              the ability to bring even the most complex projects to life. Our team of 
              skilled professionals works tirelessly to ensure every project exceeds 
              expectations.
            </p>
            
            <div className="about-features">
              <div className="feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">
                  <h4>Licensed & Insured</h4>
                  <p>Fully certified with comprehensive coverage</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">
                  <h4>Quality Materials</h4>
                  <p>We use only the best materials for lasting results</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">
                  <h4>Expert Team</h4>
                  <p>Skilled professionals with decades of experience</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">
                  <h4>On-Time Delivery</h4>
                  <p>Projects completed within agreed timelines</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="about-image">
            <div className="image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800" 
                alt="Construction team at work" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
